import { render, staticRenderFns } from "./ButtonsContainer.vue?vue&type=template&id=512f1e45"
import script from "./ButtonsContainer.vue?vue&type=script&lang=js"
export * from "./ButtonsContainer.vue?vue&type=script&lang=js"
import style0 from "./ButtonsContainer.vue?vue&type=style&index=0&id=512f1e45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports